module.exports = __webpack_public_path__ + "i_tv.ff484420.png";